import { render } from "./organisations.vue?vue&type=template&id=c7318178&ts=true"
import script from "./organisations.vue?vue&type=script&lang=ts"
export * from "./organisations.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__